import { __assign, __rest } from "tslib";
import React from 'react';
import { cnHeader } from '../Header.const';
import './Header-Search.css';
/**
 * Поисковая форма для шапки.
 * @param {HeaderSearchProps} props
 *
 */
export var HeaderSearch = function (_a) {
    var children = _a.children, className = _a.className, rest = __rest(_a, ["children", "className"]);
    return (React.createElement("form", __assign({}, rest, { className: cnHeader('Search', [cnHeader('Item'), className]) }), children));
};
